import * as types from "./actionTypes";

export const get = (type, project_id) => {
  return {
    type: types.PREMIUM_INIT_REQUEST,
    action_type: type,
    project_id
  };
};

export const getSuccess = (data) => {
  return {
    type: types.PREMIUM_INIT_SUCCESS,
    payLoad: data
  };
};

export const getFailure = () => {
  return {
    type: types.PREMIUM_INIT_FAILURE
  };
};

export const calculatePrice = (data, projectId) => {
  return {
    type: types.PREMIUM_CALCULATE_PRICE_REQUEST,
    data,
    projectId
  };
};

export const calculatePriceSuccess = (data, postedData) => {
  return {
    type: types.PREMIUM_CALCULATE_PRICE_SUCCESS,
    payLoad: data,
    postedData
  };
};

export const calculatePriceFailure = (postedData) => {
  return {
    type: types.PREMIUM_CALCULATE_PRICE_FAILURE,
    postedData
  };
};

export const useWallet = (data, projectId) => {
  return {
    type: types.PREMIUM_USE_WALLET_REQUEST,
    data,
    projectId
  };
};

export const useWalletSuccess = (data) => {
  return {
    type: types.PREMIUM_USE_WALLET_SUCCESS,
    payLoad: data
  };
};

export const useWalletFailure = () => {
  return {
    type: types.PREMIUM_USE_WALLET_FAILURE,
  };
};

export const usePromoCode = (data, projectId) => {
  return {
    type: types.PREMIUM_USE_PROMO_CODE_REQUEST,
    data,
    projectId
  };
};

export const usePromoCodeSuccess = (data) => {
  return {
    type: types.PREMIUM_USE_PROMO_CODE_SUCCESS,
    payLoad: data
  };
};

export const usePromoCodeFailure = () => {
  return {
    type: types.PREMIUM_USE_PROMO_CODE_FAILURE,
  };
};

export const savePremiumInfoInCash = (data) => {
  return {
    type: types.PREMIUM_INFO_SAVE_IN_CASH,
    data,
  };
};

export const getList = () =>{
  return{
    type: types.PREMIUM_TRANSACTION_LIST_REQUEST
  }
};

export const getListSuccess = data => {
  return {
    type: types.PREMIUM_TRANSACTION_LIST_SUCCESS,
    payLoad: data
  };
};

export const getListFailure = data => {
  return {
    type: types.PREMIUM_TRANSACTION_LIST_FAILURE,
    payLoad: data
  };
};

export const getListByProject = () =>{
  return{
    type: types.PREMIUM_TRANSACTION_LIST_BY_PROJECT_REQUEST
  }
};

export const getListByProjectSuccess = data => {
  return {
    type: types.PREMIUM_TRANSACTION_LIST_BY_PROJECT_SUCCESS,
    payLoad: data
  };
};

export const getListByProjectFailure = data => {
  return {
    type: types.PREMIUM_TRANSACTION_LIST_BY_PROJECT_FAILURE,
    payLoad: data
  };
};

export const payStore = (data, projectId) => {
  return {
    type: types.PREMIUM_PAY_REQUEST,
    data,
    projectId
  };
};

export const payStoreSuccess = (data) => {
  return {
    type: types.PREMIUM_PAY_SUCCESS,
    data
  };
};

export const payStoreFailure = () => {
  return {
    type: types.PREMIUM_PAY_FAILURE
  };
};

export const getPromoCode = () => {
  return {
    type: types.PREMIUM_PROMO_CODE_REQUEST
  };
};
export const getPromoCodeSuccess = (data) => {
  return {
    type: types.PREMIUM_PROMO_CODE_SUCCESS,
    data: data
  };
};
export const getPromoCodeFailure = () => {
  return {
    type: types.PREMIUM_PROMO_CODE_FAILURE
  };
};